import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { setAppointmentTypeStaff } from 'www/modules/Schedule/functions'
import LpuSpecialityList from 'www/vue_components/common/LpuSpecialityList/LpuSpecialityList.vue'
import LpuSpecialityListDialog from 'www/vue_components/common/LpuSpecialityList/components/common/LpuSpecialityListDialog.vue'

/**
 * @description
 *
 * Производит рендер списка специальностей списка клиник
 *
 * @param {object} options -
 * @param {object} options.items - данные, которые собраны со страницы
 * @param {object} options.storage - данные, которые собраны со страницы
 * @param {object} options.response - данные ответа, которые возвращает 'specialtiesRequest'
 */

const selectComponents = []
let lpuSpecialityDialog = null

function renderSpecialities({ items, storage, response }) {
  const { specialtyId, specialtyName, specialtyTranslit } = storage
  const isAppliedFilter = specialtyId && specialtyName && specialtyTranslit

  if (!lpuSpecialityDialog) {
    lpuSpecialityDialog = new Vue({
      vuetify,
      el: '.vue-lpu-speciality-list-mount',
      render: h => h(LpuSpecialityListDialog),
    })
  }

  selectComponents.forEach(instance => instance.$destroy())
  selectComponents.length = 0

  items.forEach(({ coverNode, lpuId }) => {
    const selectMountElement = coverNode.querySelector('.vue-select-specialities-mount') // ToDo schedule-important избавиться от привязки к DOM дереву

    if (!selectMountElement) {
      return
    }

    const specialities = response[lpuId]

    if (!specialities) {
      return
    }

    const selectedSpeciality = isAppliedFilter
      ? specialities.find(s => s.id === Number(specialtyId))
      : specialities[0]

    const props = {
      lpuId,
      options: specialities,
      selectedOption: selectedSpeciality,
    }

    const instance = new Vue({
      el: selectMountElement,
      render: h => h(LpuSpecialityList, { props }),
    })

    selectComponents.push(instance)

    setAppointmentTypeStaff({ coverNode, option: selectedSpeciality })
  })
}

export default renderSpecialities
